import {inject, Injectable} from '@angular/core';
import {Actions} from '@ngneat/effects-ng';
import {ConfigService, RefModelStoreService} from '@q9elements/ui-kit/common';
import {GridFetchParams, GridQuery, selectEntities} from '@q9elements/ui-kit/components';
import {map} from 'rxjs';
import {finalize} from 'rxjs/operators';

import {INode} from '../../../models/grid-node.interface';
import {GridNodeFormatterService} from '../../../services/grid-node-formatter.service';
import {MyMetadataEntity} from './my-metadata-entity';

@Injectable({providedIn: 'root'})
export class MyMetadataQuery extends GridQuery<MyMetadataEntity> {
  protected actions: Actions = inject(Actions);
  private rmStore = inject(RefModelStoreService);
  gridNodeFormatter = inject(GridNodeFormatterService);

  override fetchEntities(params: GridFetchParams) {
    const state = this.store.getValue();
    const refModel = this.rmStore.refModel;
    const rmId = refModel._id;
    const isSf = Boolean(refModel.sf);
    const type = this.getValue().type || '';
    const url = [
      ConfigService.environment.API_ENDPOINT,
      'stakeholders',
      isSf ? 'sf' : 'ref',
      'refmodel',
      rmId,
      'my-metadata'
    ].join('/');
    const queryParams = {
      skip: params.skip,
      limit: params.take,
      type
    };

    return super.fetchEntities<{nodes: INode[]; length: number}>(queryParams, url).pipe(
      map(({nodes, length}) => {
        return {
          entities: nodes.map(item => this.gridNodeFormatter.formatNode(item)),
          total: length
        };
      }),
      finalize(() => {
        if (state.reselectActiveEntity) {
          this.actions.dispatch(selectEntities({ids: state.active}));
          this.store.update(state => ({...state, reselectActiveEntity: false}));
        }
      })
    );
  }
}
